module.exports = __webpack_public_path__ + "img/prop-1.fa14bf4d.svg";